@if(isCartOrCheckout) {
<mat-toolbar class="cart-navigation">
    <div class="nav-container">
        <div class="nav-content container">
            <div class="left-section">
                <a class="left-section" routerLink="/home">
                    <img src="../../../assets/images/funfigz-logo.png" class="logo-image" alt="Logo" />
                </a>
            </div>

            <div class="middle-section">
                <ul class="nav-list">
                    <li
                        class="nav-link text-base"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        <a routerLink="/cart">Your Cart</a>
                    </li>
                    <div class="line"></div>
                    <li class="nav-link text-base" routerLinkActive="active">
                        <a routerLink="/address">Address</a>
                    </li>
                    <div class="line"></div>
                    <li class="nav-link text-base" routerLinkActive="active">
                        <a>Payment</a>
                    </li>
                </ul>
            </div>

            <div class="right-section">
                <mat-icon class="icon" svgIcon="safematerial"><mat-icon></mat-icon></mat-icon>
                <span class="right-section-text font-inter">100% Secure Payments</span>
            </div>
        </div>
    </div>
</mat-toolbar>
} @else {
<mat-toolbar class="navigation">
    <div class="nav-container container">
        <div class="nav-content">
            <div class="left-section">
                <a class="left-section" routerLink="/home">
                    <img src="../../../assets/images/funfigz-logo.png" class="logo-image" alt="Logo" />
                </a>
            </div>

            <div class="middle-section">
                <ul class="nav-list">
                    <li
                        class="nav-link text-base"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        <a routerLink="/products">Shop</a>
                    </li>

                    <li class="nav-link text-base" routerLinkActive="active">
                        <a routerLink="/designer">Designer</a>
                    </li>

                    <li class="nav-link text-base" routerLinkActive="active">
                        <a routerLink="/about-us">About</a>
                    </li>

                    <li class="nav-link text-base" routerLinkActive="active">
                        <a routerLink="/contact">Contact</a>
                    </li>
                </ul>
            </div>

            <div class="right-section">
                <div class="search-container">
                    <mat-icon
                        svgIcon="search"
                        class="search-icon"
                        (click)="handleSearch(searchControl.value)"
                    ></mat-icon>
                    <input
                        #desktopSearchInput
                        type="text"
                        placeholder="Search toys..."
                        [formControl]="searchControl"
                        (focus)="onInputFocus('desktop')"
                        (keyup.enter)="handleSearch(searchControl.value)"
                        class="search-input text-base"
                    />
                </div>

                <a routerLink="/wishlist">
                    <mat-icon
                        svgIcon="wishlist"
                        [matBadge]="wishlistCount ? wishlistCount : null"
                        matBadgeOverlap="true"
                        matBadgeSize="large"
                        aria-hidden="false"
                        class="wishlist-header-icon wishlist-badge"
                    ></mat-icon>
                </a>

                <a routerLink="/cart">
                    <mat-icon
                        svgIcon="cart"
                        [matBadge]="cartCount ? cartCount : null"
                        matBadgeOverlap="true"
                        matBadgeSize="large"
                        aria-hidden="false"
                        class="cart-icon cart-badge"
                    ></mat-icon>
                </a>

                @if (!isUserLogin) {
                <button mat-stroked-button class="sign-in-button" (click)="loginDialog()">Sign In</button>
                } @else {
                <button mat-icon-button class="user-icon-button icon-button-overlay-remove" [matMenuTriggerFor]="menu">
                    @if (userDetails?.user?.profileImage) {
                    <img [src]="userDetails?.user?.profileImage" class="profile-image" />
                    } @else {
                    <mat-icon svgIcon="user" class="user-icon"></mat-icon>
                    }
                </button>

                <mat-menu #menu="matMenu" class="profile-menu">
                    <div class="user-info">
                        @if(userDetails?.user?.profileImage){
                        <img [src]="userDetails?.user?.profileImage" class="user-avatar" />
                        } @else {
                        <span class="user-avatar text-xl">{{ userDetails?.user?.name || "User" | initials: 2 }}</span>
                        }

                        <div>
                            <p class="user-name text-lg" appEllipsis maxWidth="220px">
                                Hello {{ userDetails?.user?.name || "User" }}
                            </p>
                            <p class="user-phone text-sm">{{ userDetails?.mobileNumber }}</p>
                        </div>
                    </div>
                    <div class="separator"></div>
                    <button mat-menu-item class="menu-item" routerLink="/account">
                        <mat-icon svgIcon="user" class="menu-icon"></mat-icon>
                        Account
                    </button>
                    <button mat-menu-item class="menu-item" routerLink="/wishlist">
                        <mat-icon svgIcon="wishlist" class="menu-icon"></mat-icon>
                        Wishlist
                    </button>
                    <button mat-menu-item class="menu-item" routerLink="/notifications">
                        <mat-icon svgIcon="notification" class="menu-icon"></mat-icon>
                        Notifications
                    </button>
                    <button mat-menu-item class="menu-item" routerLink="account/trackOrder">
                        <mat-icon svgIcon="order" class="menu-icon"></mat-icon>
                        Order
                    </button>
                    <button mat-menu-item class="menu-item" routerLink="/contact">
                        <mat-icon svgIcon="contact" class="menu-contact-icon"></mat-icon>
                        contact Support
                    </button>
                    <div class="separator"></div>
                    <button mat-menu-item class="menu-item" (click)="onUserLogout()">
                        <mat-icon svgIcon="logout" class="menu-icon"></mat-icon>
                        Logout
                    </button>
                </mat-menu>
                }
            </div>
        </div>
    </div>
</mat-toolbar>
}
